module.exports = __webpack_public_path__ + "assets/img/powerpoint.12924acb.png";